import React, { Component } from 'react';

import handlebars from 'handlebars';
import { htmlTemplate } from './customEmail';
import { blankHtmlTemplate } from './blankEmail';
import { htmlTemplate as businessWeeklyTemplate } from '../../SubscribersPage/EmailPreview/EmailTemplate/businessWeekly';

const issueLabels = {
  en: 'Issue',
  he: 'גליון',
  fr: 'Numéro',
};

class EmailPreview extends Component {
  getHtml() {
    const {
      values: {
        subject,
        headerTitle,
        date,
        hDate,
        sponsor,
        sponsorText,
        sponsorButton,
        sponsorLink,
        headline,
        title,
        author,
        text,
        lang,
        ctaButton,
        ctaLink,
        footer,
        footerTitle,
        footerText,
        emailTemplate,
      },
    } = this.props;

    // if (!subject) return '<div />';

    const isHE = lang === 'he';

    // Business Weekly (new gold design, Oct 2026) shares the weekly template
    if (emailTemplate === 'business-weekly') {
      const bwTemplate = handlebars.compile(businessWeeklyTemplate);
      return bwTemplate({
        name: subject || '',
        headline: headline || '',
        title: title || '',
        author: author || '',
        text: text || '',
        date: date || '',
        hDate: hDate || '',
        lang,
        isHE,
        issueLabel: issueLabels[lang] || issueLabels.en,
        issue: '',
        btnLabel: ctaButton || '',
        bwLink: ctaLink || '',
        sponsorLink: sponsorLink || 'https://donate.businesshalacha.com/donate',
        footer: !footer,
        footerTitle: footerTitle || '',
        footerText: footerText || '',
        logoImg: require('../../../../assets/images/bw/logo-gold.png'),
        mastheadImg: isHE
          ? require('../../../../assets/images/bw/masthead-he.png')
          : require('../../../../assets/images/bw/masthead-en.png'),
        direction: isHE ? 'rtl' : 'ltr',
        align: isHE ? 'right' : 'left',
      });
    }

    // Use blank template if selected, otherwise use standard template
    const selectedTemplate =
      emailTemplate === 'blank-email' ? blankHtmlTemplate : htmlTemplate;
    const template = handlebars.compile(selectedTemplate);
    return template({
      name: subject || '',
      headerTitle: headerTitle || '',
      date: date || '',
      hDate: hDate || '',
      headline: headline || '',
      title: title || '',
      author: author || '',
      text: text || '',
      sponsor: !sponsor,
      sponsorText: sponsorText || '',
      sponsorButton: sponsorButton || '',
      // lang,
      footer: !footer,
      footerTitle: footerTitle || '',
      footerText: footerText || '',
      bwLink: ctaLink || '',
      btnLabel: ctaButton || '',
      sponsorLink: sponsorLink || '',
      logoHBoldImg: require('../../../../assets/images/bw/logo-h-bold.png'),
      logoLImg: require('../../../../assets/images/color-logo.svg'),
      mapImg: require('../../../../assets/images/bw/map.png'),
      direction: isHE ? 'rtl' : 'ltr', //todo move the direction to db
      align: isHE ? 'right' : 'left', //todo move the align to db
    });
  }
  render() {
    return (
      <div className="h-100 overflow-visible">
        <div dangerouslySetInnerHTML={{ __html: this.getHtml() }} />
      </div>
    );
  }
}

export default EmailPreview;
